module.exports = __webpack_public_path__ + "static/media/smallLogo.005f7adc.png";